





















































































































































































































import {
  defineComponent
} from '@nuxtjs/composition-api';
import CartItemAdditionalInformation from 'components/checkout/Cart/CartItemAdditionalInformation.vue';
import { useQuoteCartState, useQuoteCartView } from '@wemade-vsf/quote-cart';
import {
  SfSidebar,
  SfNotification,
  SfButton,
  SfHeading,
  SfProperty,
  SfLoader,
  SfCollectedProduct,
  SfQuantitySelector,
} from '@storefront-ui/vue';

export default defineComponent({
  name: 'QuoteCartSidebar',
  components: {
    SfSidebar,
    SfNotification,
    SfButton,
    SfHeading,
    SfProperty,
    SfLoader,
    SfCollectedProduct,
    SfQuantitySelector,
    CartItemAdditionalInformation
  },
  setup () {
    const { isQuoteCartSidebarOpen, toggleQuoteCartSidebar, openQuoteRequestModal } = useQuoteCartState();
    const cartView = useQuoteCartView();

    function closeSidebar() {
      if (isQuoteCartSidebarOpen.value) {
        toggleQuoteCartSidebar();
      }
    }

    return {
      ...cartView,
      closeSidebar,
      openQuoteRequestModal,
      isQuoteCartSidebarOpen,
      toggleQuoteCartSidebar
    }
  }
});
